import IWBrokerClient from "./IWBrokerClient";
import IWAppPlugin from "../plugins/IWAppPlugin";
import {PushNotifications} from "@capacitor/push-notifications";
import {isPlatform} from "@ionic/react";
import {App} from "@capacitor/app";

export class IWPushNotifications {
    private registrationPromise?: Promise<void>;

    constructor() {
        if (isPlatform('capacitor')) {
            App.addListener('appStateChange', async ({ isActive }) => {
                if(isActive) {
                    await PushNotifications.removeAllDeliveredNotifications();
                }
            });

            void (async () => {
                await this.addPushListeners();
                await this.createChannels();
                await this.register();
            })().catch(error => {
                console.error('(IWPushNotifications) Initialization failed', error);
            });
        }
    }

    async getPushEnvironment() {
        if(isPlatform('android')) {
            return 'fcm';
        }

        try {
            const {environment} = await IWAppPlugin.getPushEnvironment();
            return environment;
        }
        catch (e) {
            console.warn('(IWPushNotifications.getPushEnvironment) Unable to resolve push environment', e);
            return 'Not Available';
        }
    }

    async register() {
        if (!isPlatform('capacitor')) {
            return;
        }

        if (!this.registrationPromise) {
            this.registrationPromise = this.performRegistration()
                .finally(() => {
                    this.registrationPromise = undefined;
                });
        }

        return this.registrationPromise;
    }

    private async performRegistration() {
        let result;

        try {
            result = await IWAppPlugin.requestCriticalAlertPermissions();
        }
        catch (e) {
            console.warn("<IWPushNotifications.register> IWApp.requestCriticalAlertPermissions not successful, falling back to PushNotifications.requestPermissions", e);
            result = await PushNotifications.requestPermissions();
        }

        if (result.receive === 'granted') {
            await PushNotifications.register();
        }
        else {
            console.warn('(IWPushNotifications.register) Error requesting permission: ' + result.receive);
        }
    }

    async registerPushToken(pushToken: string, environment?: string) {
        if(!environment) {
            environment = await this.getPushEnvironment();
        }

        if(environment === 'Not Available') {
            throw new Error('Push environment is not available');
        }

        return IWBrokerClient.request('push token', {
            pushToken,
            environment
        });
    }

    async addPushListeners() {
        await PushNotifications.addListener('registration', async (token) => {
            try {
                await this.registerPushToken(token.value);
            } catch (e) {
                console.error('(IWPushNotifications) Registration request failed', e);
            }
        });

        await PushNotifications.addListener('registrationError', err => {
            console.error('(IWPushNotifications) Native registration failed', err.error);
        });
    }

    async createChannels() {
        if(isPlatform('android')) {
            try {
                await PushNotifications.createChannel({
                    description: 'Alarm System Triggered / Emergency',
                    id: 'alarm_triggered',
                    importance: 5,
                    lights: true,
                    name: 'Alarm Triggered',
                    sound: 'alarm.wav',
                    vibration: true,
                    visibility: 1,
                    lightColor: '#FF0000'
                });

                console.log('(IWPushNotifications) push channel created: alarm_triggered');
            }
            catch (error) {
                console.error('(IWPushNotifications) push channel error: ', error);
            }
        }
    }
}

const iwPushNotifications = new IWPushNotifications();

export default iwPushNotifications;
